import { Radio } from "antd"
import styles from "./StatusTabs.module.css"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { useSearchParams } from "react-router-dom"
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { REQUEST_TYPES, STATUS_TABS } from "../constants"

const StatusTabs = ({ onChangeFilters }) => {
  const { metadata } = useSelector((store) => store.bookings)

  if (metadata?.status_counts) {
    STATUS_TABS.booked.count = metadata?.status_counts.booked || 0
    STATUS_TABS.requested.count = metadata?.status_counts.requested || 0
    STATUS_TABS.completed.count = metadata?.status_counts.completed || 0
    STATUS_TABS.canceled.count = metadata?.status_counts.canceled || 0
  }

  const [searchParams] = useSearchParams()
  const type = searchParams.get("type")

  return (
    <div>
      <Radio.Group name="type" className={styles.statusTabsContainer} value={type} onChange={onChangeFilters}>
        {Object.entries(STATUS_TABS).map(([key, { label, count }]) => (
          <Radio.Button name="type" key={key} value={key} className={styles.statusTabButton}>
            {label} {count} {(key === REQUEST_TYPES.requested && !!count) && (
              <ExclamationCircleOutlined style={{ color: '#F98600' }} />
            )}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  )
}
StatusTabs.propTypes = {
  onChangeFilters: PropTypes.func.isRequired
}

export default StatusTabs
